const features = [
  {
    icon: "ri-shield-keyhole-line",
    title: "Advanced Encryption",
    description:
      "Military-grade 256-bit AES encryption protects all your data in transit, ensuring no third party can intercept or read your information.",
    large: true,
    dark: true,
  },
  {
    icon: "ri-speed-line",
    title: "High Performance",
    description:
      "Optimized algorithms ensure minimal impact on device speed and battery life while maintaining full protection.",
    large: false,
    dark: false,
  },
  {
    icon: "ri-eye-off-line",
    title: "Zero-Log Policy",
    description:
      "We never store, track, or share your browsing activity. Your privacy is absolute.",
    large: false,
    dark: false,
  },
  {
    icon: "ri-smartphone-line",
    title: "Native iOS Design",
    description:
      "Built from the ground up for iOS, following Apple's Human Interface Guidelines for a seamless, intuitive experience.",
    large: false,
    dark: false,
  },
  {
    icon: "ri-hard-drive-2-line",
    title: "Smart Storage Cleanup",
    description:
      "Intelligent scanning identifies and removes redundant files, caches, and duplicates to free up valuable storage space.",
    large: false,
    dark: false,
  },
  {
    icon: "ri-customer-service-2-line",
    title: "24/7 Support",
    description:
      "Our dedicated support team is always available to help you get the most out of your GRUNDAL applications.",
    large: false,
    dark: false,
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
          <div>
            <p className="text-xs uppercase tracking-[0.25em] text-gray-400 font-medium mb-4">
              Features
            </p>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight">
              Advanced Features<br />for Modern Users
            </h2>
          </div>
          <p className="text-gray-500 text-base max-w-xs leading-relaxed md:text-right">
            Every feature is carefully engineered to deliver maximum value with minimal complexity.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature) => (
            <div
              key={feature.title}
              className={`rounded-2xl p-8 transition-transform duration-300 hover:scale-[1.02] ${
                feature.dark
                  ? "bg-gray-900 text-white"
                  : "bg-gray-50 border border-gray-100 text-gray-900"
              } ${feature.large ? "lg:col-span-1" : ""}`}
            >
              <div
                className={`w-12 h-12 flex items-center justify-center rounded-xl mb-6 ${
                  feature.dark ? "bg-white/10" : "bg-white border border-gray-200"
                }`}
              >
                <i
                  className={`${feature.icon} text-xl ${
                    feature.dark ? "text-white" : "text-gray-700"
                  }`}
                />
              </div>
              <h3
                className={`text-lg font-semibold mb-3 ${
                  feature.dark ? "text-white" : "text-gray-900"
                }`}
              >
                {feature.title}
              </h3>
              <p
                className={`text-sm leading-relaxed ${
                  feature.dark ? "text-white/60" : "text-gray-500"
                }`}
              >
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        {/* Bottom Banner */}
        <div className="mt-16 rounded-3xl overflow-hidden relative" style={{ height: "280px" }}>
          <img
            src="https://public.readdy.ai/ai/img_res/f3931e4fe1222fab679e6f01ab5a2954.jpg"
            alt="Technology background"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-black/50 flex flex-col items-center justify-center text-center px-6">
            <p className="text-white/60 text-xs uppercase tracking-[0.3em] mb-3">Trusted Technology</p>
            <h3 className="text-white text-2xl md:text-3xl font-bold max-w-lg leading-snug">
              Security and performance, engineered for the iOS ecosystem.
            </h3>
          </div>
        </div>
      </div>
    </section>
  );
}
